export const MEL_QUE_HELP = {
  screenId: 'mel-que',
  label: 'Preguntas',
  navPath: 'MercadoLibre → Preguntas',
  keywords: ['preguntas', 'respuestas', 'consultas', 'compradores', 'mercado libre', 'mercadolibre'],
  status: 'draft',
  summary: 'Listado y gestión de preguntas recibidas en MercadoLibre.',
  sidebarItems: [
    {
      id: 'mel-questions',
      screenId: 'mel-que',
      label: 'Preguntas de MercadoLibre',
      description: 'Ver preguntas de compradores sobre tus publicaciones y responderlas.',
      detail: {
        sections: [
          {
            title: 'Listado de preguntas',
            text: 'La pantalla principal muestra las preguntas recibidas. Podés filtrar por estado (Sin responder, Respondidas, Todos).',
          },
          {
            title: 'Responder preguntas',
            text: 'Hacé clic en una pregunta para ver el detalle. Si está sin responder, podés escribir una respuesta y enviarla. La respuesta se publicará en la publicación de MercadoLibre.',
          },
        ],
      },
    },
  ],
}
